export const ROSTER_CERTIFICATION_RESTRICTED_TOOLTIP =
  'Certification is currently restricted. Please contact SEAA for details.';

export const ROSTER_ENDORSEMENT_RESTRICTED_TOOLTIP =
  'Endorsement is currently restricted. Please contact SEAA for details.';
